import { Grid, MenuItem, Select, styled, Divider } from "@mui/material";
import React, { useState } from "react";
import Input from "../../components/Components/Input";
import { useMutation, useQuery } from "react-query";
import {
  createUser,
  editUser,
  getAllUserList,
} from "./mutations/AccessMutations";
import CustomButton from "../../components/Components/Button";
import CustomDivider from "../../components/Components/CustomDivider"
import { handleToastMsg } from "../../components/Components/Toast";
import { Card } from "./styles";

const StyledSelect = styled(Select)`
padding: 0px 0px; /* Adjust padding to reduce height */
font-size: 14px; /* Adjust font size */
height: auto; /* Allow the height to adjust based on content */
width: 100%;
border-radius: 5px;
// border: 1px solid gray;
`;

function AccessManagement({ setModelToggle }) {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [userType, setUserType] = useState("");
  const [email, setEmail] = useState("");
  const [stepper, setStepper] = useState("OPTIONS");
  const [phoneNumber, setPhoneNumber] = useState(null);

  const { mutate } = useMutation(createUser);
  const { mutate: editMutate } = useMutation(editUser);

  const { data: dropdownData } = useQuery("user-list", () => getAllUserList(), {
    select: (res) => res.usertypes,
    onSuccess: (res) => {
      console.log(res);
    },
  });

  console.log({ phoneNumber });

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      name: userName,
      email: email,
      password: password,
      phoneNumber: phoneNumber,
      role: userType,
    };

    mutate(payload, {
      onSuccess: (res) => {
        console.log({ res });
        setEmail("");
        setPassword("");
        setUserName("");
        setUserType("");
        setPhoneNumber("");
        setModelToggle(false);
        handleToastMsg("Data updated successfully", "success");
      },
      onError: (res) => {
        handleToastMsg(res.message, "error");
      },
    });
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();

    const payload = {
      email: email,
      password: password,
    };

    editMutate(payload, {
      onSuccess: (res) => {
        console.log({ res });
        setEmail("");
        setPassword("");
        setUserName("");
        setUserType("");
        setModelToggle(false);
        handleToastMsg("Data updated successfully", "success");
      },
    });
  };

  return (
    <>
      {stepper === "OPTIONS" && (
        <Grid
          container
          columnGap={2}
          justifyContent={"center"}
          alignItems={"center"}
          rowGap={2}
          style={{ paddingBottom: '2%' }}
        >
          <Grid item container justifyContent={"center"} py={2}>
            <h4>Access Management</h4>
            <CustomDivider />
          </Grid>
          <Card
            item
            xs={3}
            onClick={() => {
              setStepper("CREATE_USER");
            }}
          >
            Create User
          </Card>
          <Card
            item
            xs={3}
            onClick={() => {
              setStepper("EDIT_USER");
            }}
          >
            Edit User
          </Card>
        </Grid>
      )}

      {stepper === "CREATE_USER" && (
        <Grid continer>
          <Grid item container xs={12} alignItems={"center"} justifyContent={'center'} style={{ paddingLeft: '8%', paddingTop: '4%' }}>
            <b><p>Create User</p></b>
          </Grid>
          <CustomDivider />
          <form action="" onSubmit={handleSubmit} style={{ width: "100%" }}>
            <Grid container rowGap={3} style={{ paddingLeft: '8%', paddingTop: '4%', paddingRight: '8%', }}>
              <Grid container xs={12} rowGap={3} md={6} sm={8}>
                <Grid item container xs={12} alignItems={"center"}>
                  <Grid item xs={12}>
                    <p>Name</p>
                  </Grid>
                  <Grid item xs={12}>
                    <Input
                      type="text"
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  </Grid>
                </Grid>
                <Grid item container xs={12} alignItems={"center"}>
                  <Grid item xs={12}>
                    <p>Email</p>
                  </Grid>
                  <Grid item xs={12}>
                    <Input
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Grid>
                </Grid>
                <Grid item container xs={12} alignItems={"center"}>
                  <Grid item xs={12}>
                    <p>Password</p>
                  </Grid>
                  <Grid item xs={12}>
                    <Input
                      type="text"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Grid>
                </Grid>
                <Grid item container xs={12} alignItems={"center"}>
                  <Grid item xs={12}>
                    <p>User type</p>
                  </Grid>

                  <Grid item xs={12}>
                    <StyledSelect
                      // labelId="demo-simple-select-label"
                      // id="demo-simple-select"
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={userType}
                      onChange={(e) => setUserType(e.target.value)}
                      CustomSelect
                    >
                      {Array.isArray(dropdownData) && dropdownData?.length > 0 ? (
                        dropdownData?.map((item) => (
                          <MenuItem value={item.user_type}>{item.user_type}</MenuItem>
                        ))
                      ) : (
                        <MenuItem value={""}>No data found</MenuItem>
                      )}
                    </StyledSelect>
                  </Grid>
                </Grid>
                <Grid item container xs={12} alignItems={"center"}>
                  <Grid item xs={12}>
                    <p>PhoneNumber</p>
                  </Grid>
                  <Grid item xs={12}>
                    <Input
                      type="text"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item container justifyContent={"flex-end"}>
                <CustomButton type="submit">Submit</CustomButton>
              </Grid>
            </Grid>
          </form>
        </Grid>
      )}

      {stepper === "EDIT_USER" && (
        <Grid continer>
          <Grid item container xs={12} alignItems={"center"} justifyContent={'center'} style={{ paddingLeft: '8%', paddingTop: '4%' }}>
            <b><p>Edit User</p></b>
          </Grid>
          <CustomDivider />

          <form action="" onSubmit={handleEditSubmit} style={{ width: "100%" }}>
            <Grid container rowGap={3} style={{ paddingLeft: '8%', paddingTop: '4%', paddingRight: '8%', }}>
              <Grid container xs={12} rowGap={3} md={6} sm={8}>

                <Grid item container xs={12} alignItems={"center"}>
                  <Grid item xs={12}>
                    <p>Email</p>
                  </Grid>
                  <Grid item xs={12}>
                    <Input
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Grid>
                </Grid>
                <Grid item container xs={12} alignItems={"center"}>
                  <Grid item xs={12}>
                    <p>Password</p>
                  </Grid>
                  <Grid item xs={12}>
                    <Input
                      type="text"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item container justifyContent={"flex-end"}>
                <CustomButton type="submit">Submit / சமர்ப்பிக்க</CustomButton>
              </Grid>
            </Grid>
          </form>
        </Grid>
      )}
    </>
  );
}

export default AccessManagement;
